import PCNode from '../../MineModel/Nodes/PCNode';
import Vector from '../../MineModel/Nodes/Vector';

export const BULK_IMPORT_GHOST_NODE_ID = '__bulk_import_ghost_node';

export const isBulkImportGhostNode = (nodeId: string | undefined | null): boolean => (
  nodeId === BULK_IMPORT_GHOST_NODE_ID
);

export const createBulkImportGhostNode = (
  position: { x: number; y: number; z: number },
  pipeId: string,
): PCNode => {
  const node = new PCNode({
    coords: new Vector(position.x, position.y, position.z),
    id: BULK_IMPORT_GHOST_NODE_ID,
    pipeId,
    isStope: true,
  });
  node.nodeName = 'Projected stope';
  return node;
};
